import { Component, OnInit } from '@angular/core';
import { Membro } from 'src/app/modules/_models/membro';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';

@Component({
  selector: 'app-beneficios-niveis',
  templateUrl: './beneficios-niveis.component.html',
  styleUrls: ['./beneficios-niveis.component.scss'],
})
export class BeneficiosNiveisComponent implements OnInit {
  beneficios = [];
  niveis = [];
  membro: Membro = new Membro();

  nivelSelecionado: number = 0;
  exibeSkeleton: boolean = true;

  constructor(private fidelidade: FidelidadeService) {}

  ngOnInit(): void {
    this.carregarTabelaBeneficios();
  }

  carregarTabelaBeneficios() {
    this.fidelidade.obterNiveis().subscribe(
      (sucesso) => this.processarSucessoNiveis(sucesso),
      (falha) => this.processarFalhaNiveis(falha)
    );
  }

  processarSucessoNiveis(sucesso: any) {
    sucesso = sucesso.sort((a, b) => a.id - b.id);
    this.niveis = sucesso;
    this.exibeSkeleton = false;
  }
  processarFalhaNiveis(falha: any) {
    console.error('Ocorreu um erro ao obter os níveis', falha);
  }

  selecionarNivel(idNivel: number) {
    this.nivelSelecionado = idNivel;
  }
}
